import React from 'react'

interface TrustWalletLogoProps {
    className?: string
}

export default function TrustWalletLogo({ className = '' }: TrustWalletLogoProps) {
    return (
        <svg className={className} viewBox="0 0 118 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_17698_73184)">
                <mask
                    id="mask0_17698_73184"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="118"
                    height="33"
                >
                    <path d="M117.54 0.90625H0.765625V32.5327H117.54V0.90625Z" fill="white" />
                </mask>
                <g mask="url(#mask0_17698_73184)">
                    <path
                        className="dark:fill-white fill-[#0500FF]"
                        d="M53.8281 8.38428H59.4029V11.5068C61.2293 8.70052 63.3313 8.38428 66.4081 8.38428V13.9025H65.0069C61.3197 13.9025 59.5549 15.6375 59.5549 19.0743V24.9399H53.8281V8.38428Z"
                    />
                    <path
                        className="dark:fill-white fill-[#0500FF]"
                        d="M85.01 24.9399H79.2848V23.3616C78.0344 24.8124 76.3304 25.443 74.2296 25.443C70.24 25.443 67.9844 23.0775 67.9844 18.7269V8.38428H73.71V17.4357C73.71 19.484 74.7152 20.6818 76.42 20.6818C78.1248 20.6818 79.2836 19.5142 79.2836 17.5291V8.38428H85.0092V24.9399H85.01Z"
                    />
                    <path
                        className="dark:fill-white fill-[#0500FF]"
                        d="M86.4062 19.8288H91.7686C92.013 21.0266 92.8354 21.5307 94.8134 21.5307C96.4286 21.5307 97.3727 21.1531 97.3727 20.4593C97.3727 19.9222 96.9154 19.5748 95.6074 19.2917L91.2823 18.3137C88.3883 17.653 86.9258 15.9813 86.9258 13.2995C86.9258 9.76635 89.5142 7.93799 94.5402 7.93799C99.5658 7.93799 102.033 9.71967 102.461 13.537H97.1314C97.041 12.5289 96.0035 11.9119 94.2987 11.9119C92.9287 11.9119 92.047 12.3527 92.047 13.0164C92.047 13.5837 92.6243 14.0245 93.7839 14.3105L98.3214 15.415C101.306 16.1389 102.739 17.654 102.739 20.1129C102.739 23.5196 99.7838 25.5378 94.761 25.5378C89.7378 25.5378 86.415 23.362 86.415 19.8288H86.409H86.4062Z"
                    />
                    <path
                        className="dark:fill-white fill-[#0500FF]"
                        d="M117.984 13.5337V8.38428H103.852V13.5366H108.069V24.9399H113.765V13.5337H117.984Z"
                    />
                    <path
                        className="dark:fill-white fill-[#0500FF]"
                        d="M52.2332 13.5337V8.38428H38.1016V13.5366H42.3188V24.9399H48.016V13.5337H52.2332Z"
                    />
                    <path
                        d="M1.03125 5.47477L15.0871 0.90625V32.5327C5.04705 28.3155 1.03125 20.2332 1.03125 15.6656V5.47477Z"
                        fill="#0500FF"
                    />
                    <path
                        d="M29.1418 5.47477L15.0859 0.90625V32.5327C25.126 28.3155 29.1418 20.2332 29.1418 15.6656V5.47477Z"
                        fill="url(#paint0_linear_17698_73184)"
                    />
                    <path
                        d="M29.1418 5.47477L15.0859 0.90625V32.5327C25.126 28.3155 29.1418 20.2332 29.1418 15.6656V5.47477Z"
                        fill="url(#paint1_linear_17698_73184)"
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_17698_73184"
                    x1="14.4924"
                    y1="36.5077"
                    x2="25.9978"
                    y2="-5.10531"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.26" stopColor="#48FF91" />
                    <stop offset="0.66" stopColor="#0094FF" />
                    <stop offset="0.8" stopColor="#0038FF" />
                    <stop offset="0.89" stopColor="#0500FF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_17698_73184"
                    x1="25.1457"
                    y1="-0.921622"
                    x2="14.5286"
                    y2="32.4875"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.02" stopColor="#0000FF" />
                    <stop offset="0.08" stopColor="#0094FF" />
                    <stop offset="0.16" stopColor="#48FF91" />
                    <stop offset="0.42" stopColor="#0094FF" />
                    <stop offset="0.68" stopColor="#0038FF" />
                    <stop offset="0.9" stopColor="#0500FF" />
                </linearGradient>
                <clipPath id="clip0_17698_73184">
                    <rect width="117.2" height="32" fill="white" transform="translate(0.445312 0.906738)" />
                </clipPath>
            </defs>
        </svg>
    )
}
